import { findTagDetails } from '../backEnd/Memory.js'
import {sendRequestGetLocal, sendRequestPostLocal} from '../backEnd/requesition.js'
import { TagDetails } from '../objects/TagDetails/TagDetails.js'

const _routerGetTagsInCloud ='/tags/getTags'
const _routerSetNewTagsInCloud ='/tags/setTags'
const _routerSetUpdateTagsInCloud ='/tags/setEditeTags'

export const getDataTags = async (showError) => {
    var results = []
    try {
        results = await sendRequestGetLocal(_routerGetTagsInCloud)
        if(!results.response)
        {
            let tagsDetails = new TagDetails()  
            tagsDetails.fromCloud(results[0])
            return tagsDetails

        }else throw new Error(results.response.data.sqlMessage) 
       
    } catch (error) {
        showError('ERROR BUSCAR DETALHES DAS ETIQUETAS',error.message)
    }
}

export const setSaveTags= async (tagDetails,showError) =>{
    var results
    try {
        results = await sendRequestPostLocal(_routerSetNewTagsInCloud,tagDetails.getMapFromCloud())
        if(results.status !== 200) throw new Error(results.response.data.sqlMessage)
        else return results
    } catch (error) {
        showError('ERROR AO SALVAR ETIQUETAS',error.message)    
        return {status:404}
    }
}

export const setUpdateTags = async (tagDetails,showError) => {
   
    try { 
        var results = await sendRequestPostLocal(_routerSetUpdateTagsInCloud,tagDetails.getMapFromCloud())
        if(results.status !== 200)  throw new Error(results.response.data.sqlMessage)
        else 
            await findTagDetails(showError)

        return results
    } catch (error) {
        showError('ERRO AO SALVAR EDIÇÃO DESSE MARCA',error.message)    
        return {status:404}
    }
}